import { render } from "./04_1_TribalStatus.vue?vue&type=template&id=6b7eaa94&scoped=true"
import script from "./04_1_TribalStatus.vue?vue&type=script&lang=js"
export * from "./04_1_TribalStatus.vue?vue&type=script&lang=js"

import "./04_1_TribalStatus.vue?vue&type=style&index=0&id=6b7eaa94&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7eaa94"]])

export default __exports__